// @flow

/*
  **** PLEASE DO NOT USE THIS COMPONENT! ****

  This PinRep is now deprecated and should not be used. It was replaced by the Lego PinRep, which lives
  at app/common/react/components/PinRep. This deprecated PinRep will be deleted in the near future.

  As of November 2019, this is only seen by partners.
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import getClientTrackingParams from 'app/packages/client-tracking-params';
import getVideoFromPin from 'app/common/react/components/video/utils/getVideoFromPin';
import ImpressionTracker from 'app/common/lib/react/ImpressionTracker';
import PinShapeProps from 'app/common/react/components/DeprecatedPinRep/PinShapeProps';
import PropTypes from 'prop-types';
import pwaType from 'app/common/lib/pwaType';
import StatusPinRep from 'app/common/react/components/StatusPin/StatusPinRep';
import type { State as Location } from 'app/common/redux/reducers/location';
import { isStatusPin } from 'app/common/lib/util/PinUtils';
import { type State as ReduxState } from 'app/common/redux/reducers/types';
import DeprecatedPinRep, {
  PinRepPropTypes,
  type OwnProps as PinRepProps,
} from 'app/common/react/components/DeprecatedPinRep/DeprecatedPinRep';
import { getCommerceAuxData, getRichTypes } from 'app/common/lib/CommerceUtil';

type OwnProps = {|
  componentType?: $Values<PCONST.thrift.ComponentType>,
  contextLogData?: Object,
  impressionAuxFields?: Object,
  pin: Object,
  slotIndex: number,
  viewData?: {
    pin_id?: string,
  },
  viewParameter: $Values<PCONST.thrift.ViewParameterType>,
  viewType: $Values<PCONST.thrift.ViewType>,
|};

type HOCProps = {|
  location: Location,
|};

type Props = {|
  ...PinRepProps,
  ...HOCProps,
  ...OwnProps,
|};

// Temporarily export these props while experimental PinRep is in experiment.
export type ExternalProps = {|
  ...PinRepProps,
  ...OwnProps,
|};

type State = {|
  startImpressionTimer: boolean,
|};

export class PinRepWithImpressions extends Component<Props, State> {
  state = {
    startImpressionTimer: false,
  };

  handleLoad = () => {
    this.setState({ startImpressionTimer: true });
  };

  handleError = () => {
    this.setState({ startImpressionTimer: false });
  };

  render() {
    const {
      componentType,
      contextLogData,
      impressionAuxFields,
      pin,
      slotIndex,
      location,
      viewData,
      viewType,
      viewParameter,
    } = this.props;
    const clientTrackingParams = getClientTrackingParams(pin, location);
    const video = getVideoFromPin(pin);
    const isNativeVideoAndWatchable =
      video && video.url && !!video.height && !!video.width ? true : undefined;

    // Redundant check for pin.videos to appease flow
    const videoIdStr = video && pin.videos ? pin.videos.id : undefined;

    return (
      <ImpressionTracker
        componentType={componentType}
        contextLogData={{
          ...(typeof window !== 'undefined' ? { pwa_type: pwaType(window) } : {}),
          ...contextLogData,
          ...getCommerceAuxData(pin, contextLogData),
        }}
        loggingId={pin.id}
        impressionType="Pin"
        impressionAuxFields={{
          ...(impressionAuxFields || {}),
          isNativeVideoAndWatchable,
          videoIdStr,
          richTypes: getRichTypes(pin),
          imageURL: pin.images && pin.images['236x'].url,
          clientTrackingParams: clientTrackingParams || `${pin.tracking_params}-0`,
        }}
        isPaused={!this.state.startImpressionTimer}
        slotIndex={slotIndex}
        viewData={viewData}
        viewType={viewType}
        viewParameter={viewParameter}
      >
        {isStatusPin(pin) ? (
          <StatusPinRep pin={pin} />
        ) : (
          <DeprecatedPinRep {...this.props} onError={this.handleError} onLoad={this.handleLoad} />
        )}
      </ImpressionTracker>
    );
  }
}

PinRepWithImpressions.propTypes = {
  componentType: PropTypes.number,
  contextLogData: PropTypes.objectOf(PropTypes.any),
  impressionAuxFields: PropTypes.objectOf(PropTypes.any),
  location: PropTypes.shape({
    history: PropTypes.arrayOf(
      PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string,
        previousPath: PropTypes.string,
        gridItems: PropTypes.arrayOf(PropTypes.any),
      }),
    ).isRequired,
    pathname: PropTypes.string.isRequired,
    previousPage: PropTypes.string,
  }),
  pin: PinShapeProps.isRequired,
  slotIndex: PropTypes.number.isRequired,
  viewParameter: PropTypes.number.isRequired,
  viewType: PropTypes.number.isRequired,

  ...PinRepPropTypes,
};

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default connect(({ location }: ReduxState) => ({
  location,
}))(PinRepWithImpressions);
